// extracted by mini-css-extract-plugin
export var header = "my-portal-module--header--Qf2xY";
export var iframe = "my-portal-module--iframe--WQQb2";